export const ActionTypes = {
  LOADING: "GENERATE_AI_PROS_CONS_LOADING",
  ERROR: "GENERATE_AI_PROS_CONS_ERROR",
  SUCCESS: "GENERATE_AI_PROS_CONS_SUCCESS",
};
